import { createAction } from '@reduxjs/toolkit';
export const FETCH_VOICEMAIL = 'FETCH_VOICEMAIL';
export const fetchVoicemailAction = createAction(FETCH_VOICEMAIL);
